import React, { useRef, useEffect } from "react";
import _ from "lodash";

// use when need to select multiple options (isMulti prop from react-select)
export const _findArrayOption = (list, selected) => {
  let selectedOption = [];
  selected &&
    selected.forEach((opt) => {
      const compareTo = _.isObject(opt) ? opt.value : opt;
      let listOption = list.find((option) =>
        _.isEqual(option.value, compareTo)
      );
      if (listOption) {
        selectedOption.push(listOption);
      } else {
        // if have optgroup
        for (const item of list) {
          const nestedOptions = item?.options;
          if (nestedOptions) {
            const nestedCompareTo = _.isObject(opt) ? opt.value : opt;
            let nestedListOption = nestedOptions.find((option) =>
              _.isEqual(option.value, nestedCompareTo)
            );

            if (nestedListOption) {
              selectedOption.push(nestedListOption);
            }
          }
        }
      }
    });
  return selectedOption;
};

export const _findOption = (list, selectedOpt) => {
  for (const option of list) {
    if (option?.value) {
      if (!_.isObject(selectedOpt) && _.isEqual(option.value, selectedOpt)) {
        return option;
      } else if (
        _.isObject(selectedOpt) &&
        _.isEqual(option.value, selectedOpt.value)
      ) {
        return option;
      }
    }
    if (option.options) {
      const foundOption = _findOption(option.options, selectedOpt);
      if (foundOption) {
        return foundOption;
      }
    }
  }
  return null;
};

export const _findSelectOption = (list, selectedOpt, isMulti = false) => {
  if (isMulti) {
    return _findArrayOption(list, selectedOpt);
  }

  return _findOption(list, selectedOpt);
};

export const _getBaseUrl = (path = "", themeDir = false) => {
  const baseUrl = `${window.location.protocol}//${window.location.host}`;

  if (themeDir) {
    return `${baseUrl}/themes/custom/tema/${path}`;
  }

  return `${baseUrl}/${path}`;
};

export const _isFirstRender = () => {
  const isMountedRef = useRef(true);
  useEffect(() => {
    isMountedRef.current = false;
  }, []);
  return isMountedRef.current;
};

export const _capitalized = (str) => {
  return str.charAt(0).toUpperCase() + str.slice(1);
};

export const _getSkipByPage = (page, take) => {
  const defaultSkip = 0;
  const newSkipNumber = page === 1 ? defaultSkip : (page - 1) * take;
  return newSkipNumber;
};

export const _generateRandomId = (length) => {
  let result = "";
  const characters =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  const charactersLength = characters.length;
  for (let i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  return result;
};

export const _getTranslation = (translationKey) => {
  const translationElm = document.getElementById("tema-translations");
  const translationsValues = translationElm
    ? translationElm.getAttribute("data-translations")
    : null;
  const translations = translationsValues ? JSON.parse(translationsValues) : {};

  return translationKey in translations
    ? translations[translationKey]
    : `Translation key "${translationKey}" cannot be found.`;
};

export const _getCSRFTokenValue = async () => {
  let token = null;

  await fetch(`${_getBaseUrl()}session/token`)
    .then((response) => {
      token = response.text();
    })
    .catch((error) => {
      console.error("Error fetching CSRF token:", error);
    });

  return token;
};

export const _makeId = (length) => {
  var result = "";
  var characters =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  var charactersLength = characters.length;
  for (var i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  return result;
};

export const _validateForm = (check, formData) => {
  return Object.keys(check).reduce((obj, key) => {
    if (
      formData[key] === undefined ||
      formData[key] === null ||
      formData[key] === "" ||
      formData[key].length === 0 ||
      formData[key][0] === ""
    ) {
      obj[key] = [check[key]];
    } else if (key === "email") {
      const email = formData[key];

      const regex =
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

      if (regex.test(String(email).toLowerCase()) === false) {
        obj[key] = ["Invalid email format"];
      }
    }
    return obj;
  }, {});
};

export const _getPlaceHolderKey = (type) => {
  switch (type) {
    case 'blogType':
      return 'all_type'
      break;
    case 'region':
      return 'all_region'
      break;
    case 'theme':
      return 'all_theme'
      break;
    case 'themes':
      return 'all_theme'
      break;
    case 'type':
      return 'all_type'
      break;
    case 'languages':
      return 'all_languages'
      break;

    default:
      break;
  }
};

export const findThemeByName = (tree, themeName) => {
  for (const item of tree) {
    if (item.name === themeName) {
      return item; // Found the theme
    }
    if (item.children) {
      const foundSubtheme = findThemeByName(item.children, themeName);
      if (foundSubtheme) {
        return foundSubtheme; // Found the theme in the children
      }
    }
  }
  return null; // Theme not found
};

export const findQuestionsByName = (theme, questionNames) => {
  const qids = [];

  theme.children.forEach((item) => {
    if (questionNames.includes(item.name)) {
      // maintain same structure as CheckboxTree options
      qids.push({
        id: item.qid,
        idType: "qid",
      });
    }
  });

  return qids;
};

export const getAllTids = (tree, tids = []) => {
  for (const item of tree) {
    if (item.tid) {
      tids.push({ id: item.tid, idType: "tid" });
    }
    if (item.children) {
      getAllTids(item.children, tids);
    }
  }
  return tids;
};

export const _getSelectedOption = (options, selectedValue, isTopics = false) => {
  // console.log('_getSelectedOption', options, selectedValue);

  return options.find((item) => {
    return item.value === selectedValue;
  });
}

export const _slugify = (str) => str.toLowerCase().replace(/\s+/g, '_');

export const _getTileShape = (shape, color = '#CC0000', size = 68) => {
  switch (shape) {
    case "1": // Spin
      return <svg width={ size } height={ size } viewBox="0 0 450 450" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M216.429 15.9432C221.814 15.7343 250.179 15.3169 280.226 28.9742C300.417 38.1508 317.018 51.5317 329.58 68.7616C343.896 88.394 352.171 111.989 354.217 138.946C357.815 137.541 361.611 136.484 365.573 135.826C396.396 130.704 425.532 151.572 430.653 182.436L431.512 187.604C432.33 192.987 435.944 221.448 425.668 253.177C418.763 274.497 407.244 292.686 391.428 307.25C372.513 324.658 348.481 335.881 320.007 340.614C305.683 342.994 292.706 343.286 281.041 342.152C287.751 350.874 291.985 361.659 292.608 373.496C294.228 404.361 270.509 430.943 239.613 432.58L239.584 432.545H239.573L234.881 432.794L233.053 432.766C227.838 432.698 200.407 431.665 171.485 417.517C152.098 408.041 136.143 394.806 124.042 378.197C109.206 357.807 100.937 333.443 99.4853 305.744C99.3613 303.388 99.2898 301.047 99.2707 298.723C94.1073 301.416 88.4401 303.355 82.3854 304.361C51.6917 309.461 22.4262 288.615 17.305 257.751L17.3386 257.723V257.711L16.5592 253.024L16.3782 251.186C15.8587 245.938 13.8041 218.251 24.6955 187.597C31.9907 167.052 43.4365 149.53 58.6872 135.498C77.4105 118.293 100.854 107.246 128.403 102.672C141.35 100.519 153.984 100.033 166.136 101.219C161.579 93.601 158.758 84.7864 158.258 75.2965C156.633 44.2961 180.356 17.85 211.259 16.2133L216.429 15.9432Z" fill={ color }/>
      </svg>

      break;
    
    case "2": // Badge
      return <svg width={ size } height={ size } viewBox="0 0 450 450" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M224.62 47.647C266.876 47.6495 304.484 67.5466 328.588 98.4827C336.507 88.4255 344.081 79.9728 350.261 73.3137C365.479 56.9177 390.891 55.7316 407.556 70.4275H407.563L407.556 70.4378C407.855 70.7033 408.154 70.975 408.447 71.2405C425.084 86.778 426.025 112.9 410.525 129.59C374.305 168.605 357.465 203.097 359.059 235.025C360.456 263.055 376.997 291.216 408.216 318.744C425.292 333.802 426.971 359.889 411.956 377.013C396.941 394.138 370.925 395.821 353.849 380.764C343.946 372.033 334.986 363.1 326.972 353.978C302.822 383.752 265.943 402.781 224.62 402.778C183.503 402.776 146.789 383.936 122.633 354.419C114.721 363.386 105.893 372.172 96.1522 380.762C79.0759 395.819 53.0613 394.142 38.0462 377.012C23.0312 359.888 24.7038 333.8 41.7854 318.743C73.0039 291.215 89.5454 263.054 90.9421 235.023C92.5358 203.096 75.6966 168.604 39.477 129.588C23.9776 112.899 24.9183 86.7778 41.5553 71.2405C41.8481 70.9751 42.1405 70.7032 42.4446 70.4378H42.4498L42.4446 70.4275C59.1155 55.7317 84.5211 56.9178 99.7389 73.3137C105.82 79.8662 113.25 88.1531 121.03 97.998C145.148 67.3385 182.584 47.6495 224.62 47.647Z" fill={ color }/>
      </svg>

      break;

    case "3": // Potato
      return <svg width={ size } height={ size } viewBox="0 0 450 450" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M283.556 25.1651C284.877 25.1784 286.185 25.2462 287.478 25.3634C317.944 27.1255 347.901 39.5724 371.178 62.7045C397.307 88.6709 409.884 123.002 408.917 157.024C409.214 179.306 408.476 211.649 400.68 246.368C390.555 291.478 371.04 328.818 342.675 357.331C301.944 398.285 244.945 419.621 173.134 420.829C171.532 420.875 169.929 420.89 168.326 420.876C166.458 420.884 164.58 420.883 162.692 420.864C159.464 420.832 156.312 420.484 153.265 419.858C125.983 416.398 99.5962 404.165 78.6462 383.15C52.3638 356.786 39.8536 321.84 41.1148 287.305C40.7488 265.299 41.275 232.487 49.1995 197.184C59.1672 152.715 78.3832 115.907 106.32 87.7926C148.355 45.4775 207.984 24.4154 283.556 25.1651Z" fill={ color }/>
      </svg>

      break;

    case "4": // Nano cell
      return <svg width={ size } height={ size } viewBox="0 0 450 450" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M359.69 84.7145C424.678 122.433 447.022 205.825 409.601 270.985C400.941 286.063 389.837 298.842 377.083 309.113C374.565 325.295 369.049 341.3 360.32 356.34C322.601 421.328 239.211 443.673 174.052 406.251L91.9352 359.09C26.7761 321.668 4.53275 238.655 42.2511 173.667C51.1314 158.366 62.5438 145.43 75.6535 135.08C78.062 118.554 83.5578 102.204 92.3674 86.8647C129.789 21.7055 212.801 -0.537403 277.789 37.1812L359.69 84.7145Z" fill={ color }/>
      </svg>

      break;

    case "5": // Flower
      return <svg width={ size } height={ size } viewBox="0 0 450 450" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M158.244 50.2384C167.358 20.4592 195.542 -0.739065 228.155 0.343085C260.435 1.4143 286.937 23.973 294.383 53.8287C322.039 33.9741 360.789 36.4771 385.646 61.3368C411.599 87.2931 413.18 128.387 390.393 156.19C425.057 161.714 451 192.31 449.81 228.304C448.516 267.307 415.854 297.877 376.849 296.585L372.572 296.442L387.112 314.44C411.633 344.797 406.905 389.283 376.551 413.808C349.711 435.489 311.826 434.308 286.457 412.761C274.142 435.665 249.599 450.878 221.846 449.961C190.67 448.926 164.882 427.85 156.448 399.512L144.391 408.76C113.424 432.507 69.071 426.657 45.3204 395.693C21.5734 364.726 27.4211 320.372 58.3887 296.622L61.3353 294.362C25.8061 289.598 -1.02423 258.586 0.190019 221.996C1.39876 185.572 29.9654 156.504 65.5044 153.871C42.9033 124.895 46.2451 82.9478 73.971 57.9719C97.805 36.502 132.234 34.2553 158.244 50.2384Z" fill={ color }/>
      </svg>

      break;

    case "6": // Cell
      return <svg width={ size } height={ size } viewBox="0 0 450 450" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M122.254 52.0204C178.46 -4.18583 269.58 -4.18587 325.786 52.0204C338.862 65.096 348.895 80.0614 355.886 96.0368C371.862 103.029 386.828 113.062 399.904 126.138C456.11 182.344 456.11 273.465 399.904 329.671L329.071 400.504C272.864 456.71 181.743 456.71 125.537 400.504C112.461 387.428 102.427 372.462 95.4355 356.485C79.4605 349.493 64.4943 339.462 51.4191 326.387C-4.78673 270.18 -4.78678 179.06 51.4191 122.854L122.254 52.0204Z" fill={ color }/>
      </svg>

      break;

    case "7": // Clover
      return <svg width={ size } height={ size } viewBox="0 0 450 450" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M293.626 22.6991C310.807 19.0936 328.511 19.8275 346.255 24.9223C361.769 29.3667 374.384 36.3758 382.849 42.0092C386.964 44.192 390.828 47.0151 394.293 50.4803L397.427 53.6147C397.615 53.808 397.849 54.052 398.124 54.3436L398.155 54.3747L398.195 54.3656L398.191 54.3785C399.804 55.9919 401.275 57.6949 402.609 59.4671C409.071 67.3365 419.484 82.0837 425.689 101.64C431.427 119.724 432.446 137.928 428.712 155.747C424.248 177.061 413.204 196.634 395.907 213.931C391.674 218.165 387.414 221.899 383.168 225.193C387.581 228.573 391.847 232.318 395.947 236.418C412.681 253.152 423.402 272.322 427.843 293.396C431.448 310.577 430.713 328.281 425.618 346.026C421.171 361.549 414.156 374.17 408.521 382.635C406.339 386.744 403.519 390.604 400.057 394.065L396.923 397.2C396.723 397.394 396.47 397.637 396.166 397.924L396.175 397.964L396.163 397.96C394.549 399.574 392.845 401.045 391.072 402.38C383.203 408.842 368.455 419.256 348.897 425.462C330.814 431.199 312.61 432.217 294.79 428.484C273.477 424.02 253.904 412.975 236.607 395.679C232.386 391.458 228.661 387.212 225.375 382.978C222.089 387.211 218.365 391.458 214.144 395.679C196.847 412.975 177.27 424.016 155.961 428.484C138.137 432.221 119.933 431.202 101.854 425.461C82.3413 419.269 67.616 408.891 59.7333 402.425C57.9473 401.084 56.2322 399.603 54.6072 397.978L54.6124 397.948C54.6095 397.945 54.6062 397.943 54.6033 397.94L54.602 397.942L54.5322 397.872C54.2516 397.607 54.0156 397.383 53.8278 397.2L50.6935 394.065C47.2106 390.583 44.3761 386.696 42.1888 382.558C36.5648 374.094 29.5844 361.507 25.1509 346.042C20.0601 328.302 19.3223 310.594 22.9278 293.413C27.3639 272.335 38.084 253.173 54.8218 236.435C58.9293 232.327 63.2026 228.576 67.6228 225.191C63.3698 221.894 59.1036 218.155 54.8631 213.914C37.5662 196.617 26.526 177.04 22.0579 155.731C18.3207 137.907 19.3382 119.703 25.0798 101.624C31.2779 82.0905 41.6719 67.354 48.1356 59.4775C49.4722 57.7012 50.947 55.9953 52.5638 54.3785L52.5896 54.3824C52.8882 54.065 53.1414 53.8038 53.3418 53.5979L56.4762 50.4635C59.9636 46.9761 63.8547 44.1383 67.9989 41.9498C76.4634 36.3277 89.0436 29.3541 104.498 24.9235C122.238 19.8327 139.947 19.0937 157.128 22.6991C178.206 27.1352 197.368 37.8565 214.105 54.5944C218.224 58.7128 221.984 62.9976 225.376 67.4303C228.769 62.9966 232.53 58.7116 236.648 54.5931C253.382 37.8593 272.552 27.1392 293.626 22.6991Z" fill={ color }/>
      </svg>

      break;

    case "8": // boomerang
      return <svg width={ size } height={ size } viewBox="0 0 450 450" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M213.45 17.3622C237.869 12.4962 261.604 28.3272 266.474 52.7214C267.598 58.3517 267.615 63.9454 266.682 69.2797C274.269 67.1867 282.113 65.3223 290.215 63.6935C314.634 58.7877 338.369 74.7475 343.239 99.3409C344.169 104.041 344.341 108.715 343.844 113.237C350.292 111.563 356.92 110.047 363.728 108.694C388.42 103.788 412.422 119.748 417.346 144.341C422.271 168.941 406.25 192.852 381.563 197.758C336.429 206.732 305.009 224.419 288.187 250.338C269.013 279.863 266.092 322 279.249 379.151C284.878 403.596 269.543 427.951 245.012 433.559C244.586 433.656 244.152 433.746 243.719 433.836H243.707C219.608 438.626 195.909 423.47 190.384 399.45C189.24 394.479 188.007 388.864 186.804 382.705C182.615 385.369 177.919 387.38 172.819 388.559C172.397 388.656 171.969 388.746 171.541 388.836H171.528C147.697 393.626 124.262 378.47 118.798 354.45C117.268 347.721 115.575 339.813 114.012 330.975C108.906 335.033 102.836 338.043 96.0542 339.598C95.6324 339.693 95.204 339.784 94.7759 339.873H94.7629C70.9322 344.624 47.4977 329.591 42.0337 305.765C37.4197 285.649 31.3292 254.907 31.7893 220.302C32.3517 177.574 42.871 140.101 63.0525 108.931C93.4273 62.0137 144.022 31.207 213.45 17.3622Z" fill={ color }/>
      </svg>

      break;
  
    default:
      return <svg width={ size } height={ size } viewBox="0 0 450 450" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M158.201 49.9661C167.322 20.1679 195.523 -1.04334 228.158 0.0396555C260.46 1.11163 286.979 23.6853 294.43 53.5613C322.105 33.6934 360.88 36.1982 385.753 61.0745C411.724 87.0484 413.307 128.17 390.505 155.992C425.192 161.519 451.151 192.135 449.961 228.153C448.665 267.182 415.983 297.774 376.952 296.481L372.671 296.339L387.22 314.348C411.758 344.726 407.026 389.242 376.651 413.784C349.793 435.479 311.885 434.296 286.499 412.735C274.175 435.655 249.616 450.879 221.845 449.961C190.648 448.925 164.842 427.834 156.402 399.477L144.336 408.732C113.348 432.495 68.9656 426.64 45.1991 395.655C21.4364 364.667 27.2868 320.285 58.2749 296.519L61.2247 294.256C25.6729 289.488 -1.17513 258.455 0.0396368 221.842C1.24918 185.393 29.8354 156.305 65.3979 153.669C42.7825 124.674 46.1273 82.6998 73.8715 57.7074C97.7213 36.2232 132.174 33.9726 158.201 49.9661Z" fill="#FFCC00" />
      </svg>

      break;
  }
}